import React from 'react'
import { cond, pipe, prop, and, ifElse, always, complement } from 'ramda'

const withFieldError = Component => {
  class ErrorWrapper extends React.Component {
    render () {
      return (
        <div className='br-with-error'>
          <Component {...this.props} />
          <div className='has-error-text'>
            {pipe(
              prop('meta'),
              ifElse(
                prop('touched'),
                cond([
                  [
                    and(prop('warning'), complement(prop('error'))),
                    prop('warning')
                  ],
                  [prop('error'), prop('error')]
                ]),
                always('')
              )
            )(this.props)}
          </div>
        </div>
      )
    }
  }

  return ErrorWrapper
}

export default withFieldError



// WEBPACK FOOTER //
// ./src/components/form/with-error/index.js